var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"text":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" Anuluj ")])
}
var staticRenderFns = []

export { render, staticRenderFns }